module.exports = __webpack_public_path__ + "static/media/use15.58c3eb16.jpeg";